module.exports = __webpack_public_path__ + "static/img/coupon.f81683c7.png";